import { FC } from 'react'
import { AvatarData } from '../appraisal-flow/shared/appraisal-types'
import { PerCardWithAvatar } from '../../../components/custom_components/CardWithAvatar'
import PerButtonCircle from '../../../components/custom_components/ButtonCircle'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'

interface Props {
  avatarData?: AvatarData
  firstName: string
  lastName?: string
  value: number | undefined
  onSetScoreButtonClicked: (value: number | undefined) => void
  nameType?: 'firstName' | 'you'
}

export const ScoreGridValueBox: FC<Props> = ({ avatarData, firstName, lastName = '', value, onSetScoreButtonClicked, nameType }) => {
  const content = (
    <PerFlexRow justify-content="center" align="middle" direction="column">
      <PerButtonCircle
        number={value}
        color="primary"
        variant="bold"
        size="small"
        tabIndex={-1}
        onClick={() => onSetScoreButtonClicked(value)}
      />
    </PerFlexRow>
  )
  return avatarData ? (
    <PerCardWithAvatar
      firstName={avatarData.chosenFirstName ? avatarData.chosenFirstName : avatarData.legalFirstName}
      lastName={avatarData.chosenLastName ? avatarData.chosenLastName : avatarData.legalLastName}
      nameType={nameType}
      employeeId={avatarData.id}
    >
      <PerText appearance="quote">{content}</PerText>
    </PerCardWithAvatar>
  ) : (
    <PerCardWithAvatar nameType="firstName" firstName={firstName} lastName={lastName} noAvatar>
      <PerText appearance="quote">{content}</PerText>
    </PerCardWithAvatar>
  )
}
